<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-col>
          <h1 class="ml-n1 mb-n2 mt-n4">{{$t("Vehicles")}}</h1>
        </v-col>

        <v-flex xs12>
          <v-layout row wrap>
            <v-text-field class="ml-2 mr-2"
              v-model="searchText"
              append-icon="mdi-magnify"
              :label="$t('Search')"
              solo
              hide-details
              shrink
            ></v-text-field>
            <v-checkbox
              class="mt-3 ml-2 mr-2"
              :label="ct.Show_inactive"
              v-model="showInactive"
              :color="'primary'"
            ></v-checkbox>
            <v-flex grow></v-flex>
            <v-flex grow></v-flex>
            <v-flex grow></v-flex>
          </v-layout>

          <v-layout>
          <v-btn :loading="loading" class="ml-2 mr-2" color="primary" @click="loadVehicles">
            <v-icon left>search</v-icon>
            {{ $t('Search') }}
          </v-btn>
          <v-btn v-if="this.showButton" class="ml-2 mr-2" to="create-vehicle" color="primary">
            <v-icon left>add</v-icon>
            {{$t("New")}}
          </v-btn>
          <!--<v-btn
            class="ml-2 mr-2"
            :loading="submitting"
            @click="confirmDialog = true"
            v-if="this.isAdmin"
            >
            <v-icon left>update</v-icon>
            {{"Create all Vehicle Users"}}
          </v-btn> -->
          </v-layout>
        </v-flex>

        <v-progress-linear class="mt-2" v-if="loading" :indeterminate="true"></v-progress-linear>

        <v-flex v-else xs12>
          <v-data-table
            :headers="headers"
            :items="vehicles.filter(item => (showInactive || item.DeletedDate === null))"
            class="elevation-1 mt-2"
            item-key="Id"
            :show-expand="this.carrier"
            v-if="vehicles.filter(item => (showInactive || item.DeletedDate === null)).length > 0"
          >
            <template v-slot:[`item.UpdatedDate`]="{ item }">
              {{ formatDate(item.UpdatedDate) }}
            </template>
            <template v-slot:[`item.CreatedDate`]="{ item }">
              {{ formatDate(item.CreatedDate) }}
            </template>
            <template v-slot:[`item.DeletedDate`]="{ item }">
              {{ formatDate(item.DeletedDate) }}
              <v-flex class="font-weight-bold">
                          <v-btn
                            @click="preAlterVehicleDialog(item, 0)"
                          >{{item.buttonText}}</v-btn>
                        </v-flex>
            </template>
            <template v-if="this.carrier" v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-btn color="primary" :to="{name: 'create-vehicle', params: {id: item.Id, facilityNo: item.Facility, no: item.No}}">
                  <v-icon left>edit</v-icon>
                  {{$t("Edit")}}
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>

        <v-dialog
          v-model="confirmDialog"
          max-width="400">
          <v-card>
            <v-card-title class="headline">{{"Create all Vehicle Users"}}</v-card-title>
            <v-card-text>
              {{"Are you sure?"}}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="success" @click="confirmDialog = false; createVehicleUsers();">
                {{"Yes"}}
              </v-btn>
              <v-btn
                color="primary" @click="confirmDialog = false">
                {{"No"}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="ShowAreYouSureDialog" max-width="400" persistent>
        <v-card>
          <v-card-title class="headline">{{$t("Deactivate")}}?</v-card-title>
          <template>
            <v-card-text class="font-weight-bold">{{$t("Do you want to deactivate this Vehicle?")}}</v-card-text>
          </template>
          <v-card-actions>
            <v-spacer></v-spacer>
              <template>
                <v-btn ref="yesButton" color="success" @click="ShowAreYouSureDialog = false; deactivateVehicle()">{{$t("Yes")}}</v-btn>
                <v-btn ref="noButton" color="primary" @click="ShowAreYouSureDialog = false" autofocus>{{$t("No")}}</v-btn>
              </template>
            </v-card-actions>
        </v-card>
    </v-dialog>

      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import ct from '@/core/mixins/common-translations'
import filters from '@/core/mixins/common-filters'
import formatDate from '@/core/mixins/formatDate'
import * as LocalStorage from '@/core/local-storage'
import { loadFacilities } from '@/core/archive'
import * as DateUtil from '@/core/date'
import { loadVehicles, saveVehiclesAndUsers, ReDeactivateVehicle } from '@/modules/create-vehicles/create-vehicles'
import { user } from '@/core/security'

export default {
  mixins: [ct, filters, formatDate],

  data () {
    return {
      loading: false,
      showInactive: false,
      vehicles: [],
      facilityNo: null,
      facilities: null,
      search: '',
      confirmDialog: false,
      submitting: false,
      isAdmin: false,
      searchText: '',
      carrier: false,
      createVehicles: false,
      showButton: false,
      ShowAreYouSureDialog: false,
      vehicle: null,
      action: false
    }
  },

  computed: {
    headers () {
      const res = [
        /* {
          text: this.$t('Facility'),
          value: 'Facility'
        }, */
        {
          text: this.$t('VehicleLicensePlateNo'),
          value: 'LicensePlateNo'
        },
        {
          text: this.$t('No.'),
          value: 'No'
        },
        {
          text: this.$t('Name'),
          value: 'Name'
        },
        {
          text: this.$t('Email'),
          value: 'Email'
        },
        {
          text: this.$t('Updated'),
          value: 'UpdatedDate'
        },
        {
          text: this.$t('Inactive'),
          value: 'DeletedDate'
        }
      ]

      return res
    }
  },

  methods: {

    async facilityChanged () {
      if (this.facilityNo != null) LocalStorage.save('facilityNo', this.facilityNo)
    },

    createVehicleUsers () {
      this.submitting = true
      this.vehicles.forEach(vehicle => {
        // Save Vehicle User ONLY for active vehicles with LicensePlate length >= 5 and last 5 chars is a number
        if (!vehicle.DeletedDate && vehicle.LicensePlateNo && vehicle.LicensePlateNo.length >= 5 && !isNaN(vehicle.LicensePlateNo.substr(-5))) this.saveVehicleUser(vehicle)
      })
    },
    preAlterVehicleDialog (vehicle, action) {
      this.vehicle = vehicle
      this.action = this.vehicle.DeletedDate === null ? 1 : 0
      this.ShowAreYouSureDialog = true
    },

    async deactivateVehicle () {
      this.submitting = true
      var Activate = this.action === 1
      const res = await ReDeactivateVehicle({
        Id: this.vehicle.Id,
        No: this.vehicle.No,
        LicensePlateNo: this.vehicle.LicensePlateNo,
        Facility: this.vehicle.Facility,
        Activate: Activate
      })
      if (!res.failed) {
        this.$root.$message.showSuccess('Vehicle User' + ': ' + this.vehicle.LicensePlateNo + ' Deactivated')
        this.loadVehicles()
      } else {
        this.$root.$message.showError('Vehicle User' + ': ' + this.vehicle.LicensePlateNo + ' Deactivation Failed')
      }
    },

    async saveVehicleUser (vehicle) {
      const res = await saveVehiclesAndUsers({
        Id: vehicle.Id,
        No: vehicle.No,
        LicensePlateNo: vehicle.LicensePlateNo,
        Facility: vehicle.Facility,
        Name: vehicle.Name,
        DeletedDate: vehicle.DeletedDate,
        UpdatedDate: DateUtil.getRealDate(Date.now()),
        Details: vehicle.Details
      })
      if (!res.failed) this.$root.$message.showSuccess('Vehicle User' + ': ' + vehicle.LicensePlateNo + ' Saved')
      else this.$root.$message.showError('Vehicle User' + ': ' + vehicle.LicensePlateNo + ' Save Failed')
    },

    async loadVehicles () {
      this.loading = true
      const res = await loadVehicles({ facility: this.facilityNo, searchText: this.searchText, loadDeleted: true })
      if (!res.failed) {
        this.vehicles = res.data.map(obj => ({ ...obj, Email: this.getValueFromArray(this.getItemFromArray(res.data, obj.Id, 'Details'), 'Comment2') }))
        for (let i = 0; i < this.vehicles.length; i++) {
          if (this.vehicles[i].DeletedDate !== null) {
            this.vehicles[i].buttonText = this.$t('Activate')
          } else {
            this.vehicles[i].buttonText = this.$t('Deactivate')
          }
        }
      }
      this.loading = false
      this.$forceUpdate()
      this.submitting = false
      // console.log('pip', this.vehicles)
    },

    getItemFromArray (array, findId, findPropertyName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.Id === findId)
        if (found) {
          // item exists
          result = found[findPropertyName]
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    },

    getValueFromArray (array, findName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.Name === findName)
        if (found) {
          // item exists
          result = found.Value
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    }
  },

  async mounted () {
    this.isAdmin = user.token.User.includes('Admin')
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    this.carrier = user.userDetails.find(d => d.Name === 'CarrierNo')?.Value !== ''
    this.createVehicles = user.userDetails.find(d => d.Name === 'CreateVehiclesAllCarriers')?.Value
    if (this.createVehicles === 'true' || this.carrier) {
      this.showButton = true
    }
    // console.log('pip', user, this.carrier)

    const facilitiesRes = await loadFacilities()
    if (!facilitiesRes.failed) {
      // MITH special: Let user select no facilities (by selecting facility '' ie. show vehicles from all facilities.)
      if (!facilitiesRes.data.includes('')) facilitiesRes.data.unshift({ No: '', Name: '' })
      this.facilities = facilitiesRes.data.map(item => {
        return {
          text: item.No,
          value: item.No,
          item: item
        }
      })
    }

    const storedFacilityNo = '' + LocalStorage.load('facilityNo')

    if (storedFacilityNo && this.facilities.some(e => e.item.No === storedFacilityNo)) this.facilityNo = storedFacilityNo
    else {
      this.facilityNo = null
      LocalStorage.remove('facilityNo')
    }
  }
}
</script>
